// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/flag-icons/css/flag-icons.min.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-button, .list-name-selector {
  font-family: "Dm Sans", sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-button, .list-name-selector {
  display: flex;
  flex-direction: column;
}

.rDNA-button, .list-name-selector {
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.list-profile-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 30px;
}

.top-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.list-profile-header {
  display: flex;
  margin-bottom: 5px;
  align-items: flex-start;
  justify-content: space-between;
}

.banner {
  display: flex;
  width: 100%;
  flex-direction: row;
  height: -moz-fit-content;
  height: fit-content;
  border: solid 1px #0CAD99;
  border-radius: 25px;
  padding: 20px;
  background-color: white;
  justify-content: space-between;
}

.list-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.sponsor-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 70%;
}

.sponsor-text-container {
  height: 30%;
}
.sponsor-text-container p {
  text-align: center;
  font-size: 12px;
}

.sponsor-icon-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.sponsor-icon-container img {
  margin: 10px;
  max-height: 40px;
  min-width: 45px;
  width: 80px;
  object-fit: contain;
}

.like-profile {
  grid-column: 3;
  grid-row: 1;
}

.compare-profile, .share-profile {
  cursor: pointer;
  transition: background-color 0.3s;
}

.compare-profile {
  background-color: #1B3E78;
  color: white;
  border: 2px solid #1B3E78;
  border-radius: 5px;
  padding: 10px 20px;
  margin-right: 10px;
}
.compare-profile p {
  color: white;
  margin: 0;
}
.compare-profile:hover {
  background-color: #fff;
  color: #1B3E78;
}
.compare-profile:hover p {
  color: #1B3E78;
}

.share-profile {
  border-radius: 100%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  padding: 10px;
  margin-right: 30px;
}
.share-profile span {
  font-size: 40px;
}
.share-profile:hover {
  box-shadow: 0 0 20px rgba(12, 173, 153, 0.8);
  background-color: rgba(12, 173, 153, 0.3);
}
.share-profile:active {
  background-color: #BDBDBD;
  transition: none;
}

.cluster {
  border-radius: 10px;
  margin: 10px 0;
  background-color: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.cluster-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

.elite-table {
  table-layout: fixed;
  width: 100%;
  padding: 0 5%;
  border-collapse: separate;
  border-spacing: 0 1em;
}
.elite-table tr:first-child {
  background-color: white;
}
.elite-table tr {
  background-color: #F4F7FE;
}
.elite-table th {
  width: 14%;
}
.elite-table .elite-td {
  text-align: center;
  align-items: center;
  padding: 1px 0;
  border-bottom: none;
  margin: auto;
}
.elite-table .elite-td p {
  text-align: center;
  margin: 0;
}

.cluster-title-container {
  display: flex;
}

.cluster-title {
  font-size: 25px;
  margin: 10px;
  font-weight: bold;
}

.cluster-title-name {
  color: #0CAD99;
  font-size: 25px;
  margin: 10px;
  font-weight: bold;
}

.retailer-logo {
  height: auto;
}

.retailer-leading {
  font-size: 15px;
  font-weight: bold;
}

.retailer-top {
  font-size: 13px;
}

.retailer-rest {
  font-size: 11px;
}

.list-prof-pill {
  border-radius: 10px;
  margin: 3px;
  padding: 5px 7px;
  transition: background-color 0.3s ease-out;
}
.list-prof-pill p {
  margin: 0;
  color: #2D2D2A;
  text-align: center;
}
.list-prof-pill a {
  color: #2D2D2A;
}
.list-prof-pill:hover {
  background-color: #0CAD99;
  color: white;
  cursor: pointer;
}
.list-prof-pill:hover p {
  color: white;
}
.list-prof-pill:active {
  background-color: #BDBDBD;
  transition: none;
}

.list-lists,
.list-other-clusters {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.list-name {
  width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
}

.list-name-selector-form {
  display: flex;
  flex-direction: row;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 55%;
  max-height: 75%;
}

.list-name-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 225px;
  padding: 10px;
  border-radius: 15px;
  transition: background-color 0.3s ease-out;
  white-space: normal;
  overflow-wrap: break-word !important;
  background-color: #3792BF;
  color: white;
  border: none;
}
.list-name-selector option {
  font-size: 20px;
  background-color: white;
  text-wrap: wrap;
  white-space: normal;
}
.list-name-selector:hover {
  background-color: #e7e7e7;
}
.list-name-selector:active {
  background-color: rgba(12, 173, 153, 0.8);
  transition: none;
}

.flag-icon {
  width: 250px;
  height: 100px;
}

img {
  width: 100px;
  height: 150px;
}

.list-profile-container .chart {
  width: 400px;
  height: 600px;
}

.profile-table {
  width: 100%;
  border-bottom: 1px solid #ccc;
  border-collapse: collapse;
}
.profile-table td {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  width: 50%;
}
.profile-table tr {
  padding: 10px;
}
.profile-table tr a {
  display: flex;
  align-items: center;
  text-decoration: none;
  width: -moz-fit-content;
  width: fit-content;
}
.profile-table tr a span {
  margin-right: 3px;
  font-size: 20px;
  color: #2D2D2A;
}

.table-container {
  width: 100%;
  margin-left: 30px;
}

.table-logo-container {
  display: flex;
  justify-content: center;
  height: 30px;
}

.table-logo {
  display: block;
  width: 80px;
  height: 30px;
  object-fit: contain;
}

.sm-flag-icon {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.table-expand-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1B3E78;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 10px 10px 10px rgba(231, 231, 231, 0.7);
  margin-bottom: 10px;
  max-width: 95vw;
}
.table-expand-button span {
  color: white;
  margin-left: 5px;
}
.table-expand-button p {
  color: #fff;
  font-weight: bold;
}

h1 {
  color: #2D2D2A;
}

.heading {
  text-align: center;
}
.heading a {
  color: #2D2D2A;
}

.pill-container {
  display: flex;
  flex-wrap: wrap;
}

.major-market-pill {
  width: -moz-fit-content;
  width: fit-content;
  margin: 3px;
  padding: 5px;
}

.echelon-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.echelon {
  transition: width 0.3s ease;
  margin-top: 20px;
}

.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.disabled:hover {
  background-color: #ccc;
  opacity: 0.5;
}

.crumbtrail p {
  margin: 0;
}

.active-crumb {
  color: #1B3E78;
  font-weight: bolder;
}

.inactive-crumb {
  color: black;
}

.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 20px;
  margin-left: 30px;
  justify-content: space-evenly;
}
.buttons div {
  width: -moz-fit-content;
  width: fit-content;
}

.rDNA-button {
  border-radius: 15px;
  border: none;
  font-size: 16px;
  height: 48px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 225px;
}
.rDNA-button:last-of-type {
  margin-bottom: 5px;
}
.rDNA-button span {
  margin-left: 10px;
}
.rDNA-button:hover {
  opacity: 0.8;
  cursor: pointer;
}

.share-btn {
  color: #fff;
  background: #3792BF;
}

.compare-btn {
  color: #fff;
  background: #0CAD99;
  margin-left: 10px;
}

.data-btn {
  color: #fff;
  background: #3792BF;
  border: none;
  transition: background-color 0.3s ease-out;
}

.datalocked-btn {
  color: #1B3E78;
  background: #e7e7e7;
  border: none;
  transition: background-color 0.3s ease-out;
}

.padlock-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.padlock {
  display: none;
}

.padlock.disabled {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: left;
  background: radial-gradient(circle, rgba(76, 76, 71, 0.3137254902) 70%, rgba(255, 255, 255, 0.3137254902) 100%);
  position: absolute;
  z-index: 2;
}
.padlock.disabled span {
  font-size: 20px;
}
.padlock.disabled .link {
  width: 100%;
  height: 100%;
  align-items: start;
  justify-content: end;
}

.header-title-chips {
  width: 100%;
  padding: 10px;
  border-radius: 12px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.header-title-label {
  font-weight: bold;
  font-size: 14px;
  margin: 0 20px;
}

.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
.selected-chips .chip {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 12px;
  padding: 7px 10px;
  font-size: 14px;
  color: #333;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.selected-chips .chip--retailer {
  border: 2px solid #1B3E78;
}
.selected-chips .chip--ranking {
  border: 2px solid #0CAD99;
}
.selected-chips .chip--sector {
  border: 2px solid #3792BF;
}
.selected-chips .chip--cluster {
  border: 2px solid #AACCFF;
}
.selected-chips .chip .remove-chip {
  margin-left: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.selected-chips .chip .remove-chip:hover {
  color: #333;
}

.export-dropdown-container {
  position: relative;
}

.export-dropdown {
  position: absolute;
  z-index: 99;
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);
  border-radius: 3px;
  left: 50%;
  transform: translateX(6%);
  margin-top: 5px;
}

.export-btn-container {
  width: 200px !important;
  padding: 16px 20px;
  background-color: white;
  color: #4c4c47;
  box-sizing: border-box;
}
.export-btn-container span {
  font-size: 15px;
}

.export-btn-container:hover {
  background-color: #e7e7e7;
  cursor: pointer;
}

.export-dropdown-container-mobile {
  display: none !important;
}

@media screen and (min-width: 1675px) {
  .echelon-container {
    justify-content: space-between;
  }
  .export-btn-container {
    width: 201px !important;
  }
}
@media screen and (max-width: 1439.7px) {
  .list-profile-header {
    align-items: stretch;
  }
  .list-name {
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .buttons {
    flex-direction: row;
    align-items: top;
    justify-content: center;
  }
  .share-btn {
    margin-right: 10px;
    width: 225px;
  }
  .export-dropdown {
    transform: translateX(6%);
    margin-top: 0;
  }
  .export-btn-container {
    width: 202px !important;
  }
}
@media screen and (max-width: 1199.7px) {
  .list-name {
    flex-direction: column;
  }
  .buttons {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .header-title-chips {
    width: 66vw;
  }
  .buttons-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .share-btn, .rDNA-button {
    width: 350px;
  }
  .compare-btn {
    margin-left: 0;
  }
  .export-btn-container {
    width: 305px !important;
  }
}
@media screen and (max-width: 1023.7px) {
  .list-name {
    flex-direction: column;
  }
  .buttons {
    flex-wrap: nowrap;
    flex-direction: column;
  }
  .buttons button {
    margin: 5px 0 5px 0;
  }
  .header-title-chips {
    width: 66vw;
  }
  .export-btn-container {
    width: 305px !important;
  }
}
@media (max-width: 767px) {
  .list-profile-container {
    margin: 5px;
  }
  .list-name {
    flex-direction: column;
    align-items: center;
  }
  .list-name-selector-form {
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
  }
  .list-name-selector {
    width: 100%;
    font-size: 20px;
  }
  .list-logo {
    width: 70%;
    margin-left: 10px;
  }
  .flag-icon {
    width: 200px;
    height: 100%;
    margin: 0;
  }
  .banner {
    display: flex;
    flex-direction: column;
    height: -moz-fit-content;
    height: fit-content;
    align-items: center;
  }
  .sponsor-area {
    width: 90vw;
  }
  .buttons {
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-left: 0;
  }
  .buttons div {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }
  .rDNA-button,
  .share-btn,
  .compare-btn,
  .data-btn {
    width: 350px;
    margin-right: 0;
  }
  .cluster {
    width: 100vw;
  }
  .top-container {
    width: 95vw;
  }
  img {
    margin-left: 25px;
  }
  tr {
    border-bottom: 1px solid #e7e7e7;
  }
  .table-container {
    margin-left: 0;
  }
  .profile-table {
    margin: 0;
    width: auto;
  }
  .profile-table th, .profile-table td, .profile-table span, .profile-table p {
    font-size: 11px;
  }
  .table-logo-container {
    margin-left: 0;
    align-items: center;
  }
  .table-logo {
    margin: 0;
    max-width: 100%;
    max-height: 60%;
  }
  .elite-table {
    padding: 0 1%;
    word-wrap: break-word;
  }
  .elite-table th {
    width: 15%;
  }
  .elite-table th:first-child {
    width: 7%;
  }
  .elite-table th:last-child {
    width: 7%;
  }
  .sm-flag-icon {
    width: 20px;
    height: 20px;
  }
  .table-expand-button {
    width: 100vw;
    max-width: 100vw;
  }
  .header-title-chips {
    width: 95vw;
  }
  .export-dropdown-container {
    display: none !important;
  }
  .export-dropdown-container-mobile {
    position: relative;
  }
  .export-dropdown-mobile {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0;
    z-index: 99;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.254), 0 3px 10px rgba(0, 0, 0, 0.18);
    border-radius: 3px;
    width: 300px !important;
    flex-direction: column;
  }
  .export-btn-container {
    width: 300px !important;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./src/app/profiles/list-profile/list-profile.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_flexboxes.scss"],"names":[],"mappings":"AAAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ACCF;ADCE;EACE,4BAAA;ACCJ;ADCI;EACE,YAAA;ACCN;;AFbA,sBAAA;AGME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ADWJ;ACRM;EACE,sHAAA;ADUR;ACNI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ADQN;ACLI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ADON;ACJI;EACE,mBAAA;EACA,sBAAA;ADMN;;ACCE;EACE,qCAAA;ADEJ;ACCE;EACE,0BAAA;ADCJ;;ACKE;EACE,0BAAA;ADFJ;ACKE;EACE,uFAAA;ADHJ;;AE1DA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AF2DA;;AExDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AF2DJ;;AEvDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AFwDJ;;AEnDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AFoBR;;AEdA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AFyEb;;AEZA;EAAa,YAAA;AFgBb;;AEfA;EAAO,SAAA;EAAW,iDAAA;AFoBlB;;AEjBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AFkBJ;AEhBI;EACI,YAAA;EACA,SAAA;AFkBR;;AEfA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AFkBF;;AEfA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AFkBF;;AEfA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AFkGb;AEhBI;EACI,cAnFK;AFqGb;;AEdA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AF6Ff;AEfE;EACE,cA/EW;AFgGf;;AEbA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AFgBJ;;AGpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHuKF;AGpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHsKF;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHqKF;AGlKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHoKF;AGjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHmKF;AGhKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHkKF;AG/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHiKF;AG9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHgKF;AG7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AH+JF;AG5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH8JF;AG3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH6JF;AG1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH4JF;AGzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH2JF;AGxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH0JF;AGvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHyJF;AGtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHwJF;AGrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHuJF;AGpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHsJF;AI1QA;;;;;uBAAA;AC+BA;ECtBE,kCFXY;EEYZ,eDqB2C;ECpB3C,gBAXqF;EAYrF,kBALgB;AN+QlB;;AO5RA;EAC0B,aAAA;EACA,sBAAA;AP+R1B;;AOvRA;EAC0B,uBAAA;EACA,mBAAA;AP0R1B;;AGvSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AH0SF;AGvSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHySF;AGtSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHwSF;AGrSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHuSF;AGpSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHsSF;AGnSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHqSF;AGlSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHoSF;AGjSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHmSF;AGhSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHkSF;AG/RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHiSF;AG9RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AHgSF;AG7RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH+RF;AG5RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH8RF;AG3RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH6RF;AG1RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AH4RF;AGzRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH2RF;AGxRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AH0RF;AGvRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHyRF;AI7YA;;;;;uBAAA;AJCA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAoZJ;;AAjZA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAoZJ;;AAjZA;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;AAoZJ;;AAjZA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAEA,8BAAA;AAmZJ;;AAhZA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAmZJ;;AAhZA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AAmZJ;;AAhZA;EACI,WAAA;AAmZJ;AAjZI;EACI,kBAAA;EACA,eAAA;AAmZR;;AA/YA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAkZJ;AA/YI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAiZR;;AA5YA;EACI,cAAA;EACA,WAAA;AA+YJ;;AA5YA;EACI,eAAA;EACA,iCAAA;AA+YJ;;AA5YA;EACI,yBIzES;EJ0ET,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA+YJ;AA7YI;EACI,YAAA;EACA,SAAA;AA+YR;AA5YI;EACI,sBAAA;EACA,cIvFK;AJqeb;AA5YQ;EACI,cI1FC;AJweb;;AAzYA;EACI,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;AA4YJ;AA1YI;EACI,eAAA;AA4YR;AAzYI;EACI,4CAAA;EACA,yCAAA;AA2YR;AAxYI;EACI,yBI3GE;EJ4GF,gBAAA;AA0YR;;AAtYA;EACI,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAyYJ;;AAtYA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAyYJ;;AAtYA;EACI,mBAAA;EACA,WAAA;EACA,aAAA;EAEA,yBAAA;EACA,qBAAA;AAwYJ;AAtYI;EACI,uBAAA;AAwYR;AArYI;EACI,yBI9IS;AJqhBjB;AApYI;EACI,UAAA;AAsYR;AAnYI;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EAEA,YAAA;AAoYR;AAnYQ;EACI,kBAAA;EACA,SAAA;AAqYZ;;AA/XA;EACI,aAAA;AAkYJ;;AA/XA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;AAkYJ;;AA/XA;EACI,cE7IW;EF8IX,eAAA;EACA,YAAA;EACA,iBAAA;AAkYJ;;AA/XA;EACI,YAAA;AAkYJ;;AA/XA;EACI,eAAA;EACA,iBAAA;AAkYJ;;AA/XA;EACI,eAAA;AAkYJ;;AA/XA;EACI,eAAA;AAkYJ;;AA/XA;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,0CAAA;AAkYJ;AAhYI;EACI,SAAA;EACA,cErMK;EFsML,kBAAA;AAkYR;AA/XI;EACI,cE1MK;AF2kBb;AA9XI;EACI,yBI9NS;EJ+NT,YAAA;EACA,eAAA;AAgYR;AA9XQ;EACI,YAAA;AAgYZ;AA5XI;EACI,yBIrOE;EJsOF,gBAAA;AA8XR;;AA1XA;;EAEI,aAAA;EACA,mBAAA;EACA,mBAAA;AA6XJ;;AA1XA;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;AA6XJ;;AA1XA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,eAAA;AA6XJ;;AA1XA;EAII,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBIlRM;EJmRN,YAAA;EACA,YAAA;AA0XJ;AAxXI;EACI,eAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AA0XR;AAvXI;EACI,yBAAA;AAyXR;AAtXI;EACI,yCAAA;EACA,gBAAA;AAwXR;;AApXA;EACI,YAAA;EACA,aAAA;AAuXJ;;AApXA;EACI,YAAA;EACA,aAAA;AAuXJ;;AApXA;EACI,YAAA;EACA,aAAA;AAuXJ;;AApXA;EACI,WAAA;EACA,6BAAA;EACA,yBAAA;AAuXJ;AArXI;EACI,6BAAA;EACA,aAAA;EACA,UAAA;AAuXR;AApXI;EACI,aAAA;AAsXR;AApXQ;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EAAA,kBAAA;AAsXZ;AApXY;EACI,iBAAA;EACA,eAAA;EACA,cE9TH;AForBb;;AAhXA;EACI,WAAA;EACA,iBAAA;AAmXJ;;AAhXA;EACI,aAAA;EAAc,uBAAA;EAAuB,YAAA;AAqXzC;;AAlXA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAqXJ;;AAlXA;EACI,WAAA;EAAY,YAAA;EAAY,mBAAA;AAuX5B;;AArXA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBIjXQ;EJkXR,gCAAA;EACA,mDAAA;EACA,mBAAA;EACA,eAAA;AAwXJ;AAtXI;EACI,YAAA;EACA,gBAAA;AAwXR;AArXI;EACI,WI5XK;EJ6XL,iBAAA;AAuXR;;AAnXA;EACI,cE7WS;AFmuBb;;AAnXA;EACI,kBAAA;AAsXJ;AApXI;EACI,cEpXK;AF0uBb;;AAlXA;EACI,aAAA;EACA,eAAA;AAqXJ;;AAlXA;EACI,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,YAAA;AAqXJ;;AAlXA;EACI,aAAA;EACA,eAAA;EACA,6BAAA;AAqXJ;;AAlXA;EACI,2BAAA;EACA,gBAAA;AAqXJ;;AAlXA;EACI,sBAAA;EACA,mBAAA;AAqXJ;AAnXI;EACI,sBAAA;EACA,YAAA;AAqXR;;AAhXI;EACI,SAAA;AAmXR;;AA/WA;EACI,cIhbS;EJibT,mBAAA;AAkXJ;;AA/WA;EACI,YAAA;AAkXJ;;AA/WA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EAEA,iBAAA;EACA,6BAAA;AAiXJ;AA/WI;EACI,uBAAA;EAAA,kBAAA;AAiXR;;AA5WA;EACI,mBAAA;EAIA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA4WJ;AA1WI;EACI,kBAAA;AA4WR;AAzWI;EACI,iBAAA;AA2WR;AAxWI;EACI,YAAA;EACA,eAAA;AA0WR;;AAtWA;EACI,WIveS;EJweT,mBIleM;AJ20BV;;AAtWA;EACI,WI5eS;EJ6eT,mBI/eS;EJgfT,iBAAA;AAyWJ;;AAtWA;EACI,WIlfS;EJmfT,mBI7eM;EJ8eN,YAAA;EACA,0CAAA;AAyWJ;;AAvWA;EACI,cIpfS;EJqfT,mBEtcc;EFucd,YAAA;EACA,0CAAA;AA0WJ;;AArWE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAwWJ;;AAlWE;EACE,aAAA;AAqWJ;;AAjWE;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,+GAAA;EACA,kBAAA;EACA,UAAA;AAmWJ;AAlWI;EACI,eAAA;AAoWR;AAlWG;EACK,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AAoWR;;AA9VA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAiWF;;AA9VA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAiWF;;AA9VA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AAiWF;AA/VE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;AAiWJ;AA/VI;EACE,yBAAA;AAiWN;AA9VI;EACE,yBAAA;AAgWN;AA7VI;EACE,yBAAA;AA+VN;AA5VI;EACE,yBAAA;AA8VN;AA3VI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AA6VN;AA3VM;EACE,WAAA;AA6VR;;AAvVA;EACE,kBAAA;AA0VF;;AAvVA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,8EAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;AA0VF;;AAvVA;EACE,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cE1kBiB;EF2kBjB,sBAAA;AA0VF;AAvVE;EACE,eAAA;AAyVJ;;AArVA;EACE,yBEnlBgB;EFolBhB,eAAA;AAwVF;;AArVA;EACE,wBAAA;AAwVF;;AAnVA;EACI;IACI,8BAAA;EAsVN;EApVE;IACE,uBAAA;EAsVJ;AACF;AAnVA;EACI;IACI,oBAAA;EAqVN;EAnVE;IACI,sBAAA;IACA,mBAAA;IACA,6BAAA;EAqVN;EAnVE;IACI,mBAAA;IACA,gBAAA;IACA,uBAAA;EAqVN;EAlVE;IACI,kBAAA;IACA,YAAA;EAoVN;EAjVA;IACE,yBAAA;IACA,aAAA;EAmVF;EAhVA;IACE,uBAAA;EAkVF;AACF;AA/UA;EACI;IACI,sBAAA;EAiVN;EA/UE;IACI,sBAAA;IACA,mBAAA;IACA,uBAAA;EAiVN;EA/UA;IACE,WAAA;EAiVF;EA3UE;IACI,sBAAA;IACA,mBAAA;IACA,uBAAA;EA6UN;EA3UE;IACE,YAAA;EA6UJ;EA3UE;IAEE,cAAA;EA4UJ;EAzUA;IACE,uBAAA;EA2UF;AACF;AAvUA;EACI;IACI,sBAAA;EAyUN;EAvUE;IACI,iBAAA;IACA,sBAAA;EAyUN;EAvUM;IACI,mBAAA;EAyUV;EAtUA;IACE,WAAA;EAwUF;EAtUA;IACE,uBAAA;EAwUF;AACF;AArUA;EACI;IACI,WAAA;EAuUN;EApUE;IACI,sBAAA;IACA,mBAAA;EAsUN;EAnUE;IACI,uBAAA;IAAA,kBAAA;IACA,eAAA;EAqUN;EAlUE;IACI,WAAA;IACA,eAAA;EAoUN;EAjUE;IACI,UAAA;IACA,iBAAA;EAmUN;EAhUE;IACI,YAAA;IACA,YAAA;IACA,SAAA;EAkUN;EA/TE;IACI,aAAA;IACA,sBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,mBAAA;EAiUN;EA9TE;IACI,WAAA;EAgUN;EA7TE;IACI,sBAAA;IACA,mBAAA;IACA,WAAA;IAEA,cAAA;EA8TN;EA7TM;IAEI,WAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;EA8TV;EA1TE;;;;IAII,YAAA;IACA,eAAA;EA4TN;EAxTE;IACI,YAAA;EA0TN;EAvTE;IACI,WAAA;EAyTN;EAtTE;IACI,iBAAA;EAwTN;EArTE;IACI,gCAAA;EAuTN;EApTE;IACI,cAAA;EAsTN;EAnTE;IACI,SAAA;IACA,WAAA;EAqTN;EAnTM;IACI,eAAA;EAqTV;EAjTE;IACI,cAAA;IACA,mBAAA;EAmTN;EAhTE;IACI,SAAA;IACA,eAAA;IACA,eAAA;EAkTN;EA/SE;IACI,aAAA;IACA,qBAAA;EAiTN;EA/SM;IACI,UAAA;EAiTV;EA/SM;IACI,SAAA;EAiTV;EA/SM;IACI,SAAA;EAiTV;EA7SE;IACI,WAAA;IAAY,YAAA;EAgTlB;EA7SE;IACI,YAAA;IACA,gBAAA;EA+SN;EA7SA;IACE,WAAA;EA+SF;EA5SA;IACE,wBAAA;EA8SF;EA3SA;IACE,kBAAA;EA6SF;EAzSA;IACE,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,aAAA;IAEA,WAAA;IACA,uBAAA;IACA,0EAAA;IACA,kBAAA;IACA,uBAAA;IACA,sBAAA;EA0SF;EAxSA;IACE,uBAAA;EA0SF;AACF","sourcesContent":["/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import '../../../styles.scss';\n@import \"/node_modules/flag-icons/css/flag-icons.min.css\";\n@import \"placeholders/fonts\";\n@import \"placeholders/flexboxes\";\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import \"variables\";\n\n.list-profile-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-left: 30px;\n}\n\n.top-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n}\n\n.list-profile-header {\n    display: flex;\n    margin-bottom: 5px;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.banner {\n    display:flex;\n    width:100%;\n    flex-direction: row;\n    height:fit-content;\n    border: solid 1px $theme-accent;\n    border-radius: 25px;\n    padding: 20px;\n    background-color: white;\n\n    justify-content: space-between;\n}\n\n.list-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n}\n\n.sponsor-area {\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    width:70%;\n}\n\n.sponsor-text-container {\n    height:30%;\n\n    p {\n        text-align:center;\n        font-size:12px\n    }\n}\n\n.sponsor-icon-container {\n    display:flex;\n    flex-direction:row;\n    justify-content: space-evenly;\n    flex-wrap:wrap;\n\n\n    img {\n        margin:10px;\n        max-height:40px;\n        min-width:45px;\n        width:80px;\n        object-fit: contain;\n\n    }\n}\n\n.like-profile {\n    grid-column: 3;\n    grid-row: 1;\n}\n\n.compare-profile, .share-profile {\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.compare-profile {\n    background-color: $theme-main;\n    color: white;\n    border: 2px solid $theme-main;\n    border-radius: 5px;\n    padding: 10px 20px;\n    margin-right: 10px;\n\n    p {\n        color: white;\n        margin: 0;\n    }\n\n    &:hover {\n        background-color: #fff;\n        color: $theme-main;\n\n        p {\n            color: $theme-main;\n        }\n    }\n}\n\n.share-profile {\n    border-radius: 100%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n    padding: 10px;\n    margin-right: 30px;\n\n    span {\n        font-size: 40px;\n    }\n\n    &:hover {\n        box-shadow: 0 0 20px rgba($theme-contrast, 0.8);\n        background-color: rgba($theme-contrast, 0.3);\n    }\n\n    &:active {\n        background-color: $theme-3;\n        transition: none;\n    }\n}\n\n.cluster {\n    border-radius: 10px;\n    margin: 10px 0;\n    background-color: white;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.cluster-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    width:100%;\n}\n\n.elite-table {\n    table-layout: fixed;\n    width:100%;\n    padding:0 5%;\n\n    border-collapse:separate;\n    border-spacing:0 1em;\n\n    tr:first-child {\n        background-color: white;\n    }\n\n    tr {\n        background-color: $app-background;\n    }\n\n    th {\n        width:14%;\n\n    }\n    .elite-td {\n        text-align: center;\n        align-items: center;\n        padding: 1px 0;\n        border-bottom:none;\n\n        margin:auto;\n        p {\n            text-align: center;\n            margin:0;\n        }\n    }\n\n}\n\n.cluster-title-container {\n    display:flex;\n}\n\n.cluster-title {\n    font-size: 25px;\n    margin: 10px;\n    font-weight:bold;\n}\n\n.cluster-title-name {\n    color:$theme-accent;\n    font-size: 25px;\n    margin: 10px;\n    font-weight:bold;\n}\n\n.retailer-logo {\n    height: auto;\n}\n\n.retailer-leading {\n    font-size: 15px;\n    font-weight: bold;\n}\n\n.retailer-top {\n    font-size: 13px;\n}\n\n.retailer-rest {\n    font-size: 11px;\n}\n\n.list-prof-pill {\n    border-radius: 10px;\n    margin: 3px;\n    padding: 5px 7px;\n    transition: background-color 0.3s ease-out;\n\n    p {\n        margin: 0;\n        color: $theme-back;\n        text-align: center;\n    }\n\n    a {\n        color: $theme-back;\n    }\n\n    &:hover {\n        background-color: $theme-contrast;\n        color:white;\n        cursor: pointer;\n\n        p {\n            color:white;\n        }\n    }\n\n    &:active {\n        background-color: $theme-3;\n        transition: none;\n    }\n}\n\n.list-lists,\n.list-other-clusters {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.list-name {\n    width: 100%;\n    max-height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    cursor: pointer;\n}\n\n.list-name-selector-form {\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n    max-width: 55%;\n    max-height: 75%;\n}\n\n.list-name-selector {\n    @extend %font-20px-medium;\n    @extend %flex-column;\n    @extend %flex-jCenter-aCenter;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    width: 225px;\n    padding: 10px;\n    border-radius: 15px;\n    transition: background-color 0.3s ease-out;\n    white-space: normal;\n    overflow-wrap: break-word !important;\n    background-color: $theme-1;\n    color:white;\n    border:none;\n\n    option {\n        font-size: 20px;\n        background-color: white;\n        text-wrap: wrap;\n        white-space: normal;\n    }\n\n    &:hover {\n        background-color: rgba($theme-lightgray, 1);\n    }\n\n    &:active {\n        background-color: rgba($theme-contrast, 0.8);\n        transition: none;\n    }\n}\n\n.flag-icon {\n    width: 250px;\n    height: 100px;\n}\n\nimg {\n    width: 100px;\n    height: 150px;\n}\n\n.list-profile-container .chart {\n    width: 400px;\n    height: 600px;\n}\n\n.profile-table {\n    width: 100%;\n    border-bottom: 1px solid #ccc;\n    border-collapse: collapse;\n\n    td {\n        border-bottom: 1px solid #ccc;\n        padding: 10px;\n        width: 50%;\n    }\n\n    tr {\n        padding: 10px;\n\n        a {\n            display: flex;\n            align-items: center;\n            text-decoration: none;\n            width: fit-content;\n\n            span {\n                margin-right: 3px;\n                font-size: 20px;\n                color: $theme-back;\n            }\n        }\n    }\n}\n\n.table-container {\n    width:100%;\n    margin-left:30px;\n}\n\n.table-logo-container {\n    display:flex; justify-content:center;height:30px;\n}\n\n.table-logo {\n    display:block;\n    width:80px;\n    height:30px;\n    object-fit: contain;\n}\n\n.sm-flag-icon {\n    width:30px; height:30px;border-radius:100%;\n}\n.table-expand-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: $dark-text;\n    border-radius: 0px 0px 10px 10px;\n    box-shadow: 10px 10px 10px rgba($theme-lightgray, 0.7);\n    margin-bottom: 10px;\n    max-width: 95vw;\n\n    span {\n        color: white;\n        margin-left: 5px;\n    }\n\n    p {\n        color: $light-text;\n        font-weight: bold;\n    }\n}\n\nh1 {\n    color: $theme-back;\n}\n\n.heading {\n    text-align: center;\n\n    a {\n        color: $theme-back;\n    }\n}\n\n.pill-container {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.major-market-pill {\n    width: fit-content;\n    margin: 3px;\n    padding: 5px;\n}\n\n.echelon-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n\n.echelon {\n    transition: width 0.3s ease;\n    margin-top: 20px;\n}\n\n.disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n\n    &:hover {\n        background-color: #ccc;\n        opacity: 0.5;\n    }\n}\n\n.crumbtrail {\n    p {\n        margin: 0;\n    }\n}\n\n.active-crumb {\n    color: $theme-main;\n    font-weight: bolder;\n}\n\n.inactive-crumb {\n    color: black;\n}\n\n.buttons {\n    display: flex;\n    flex-direction: row;\n    width:100%;\n    margin-top: 20px;\n    //align-items: flex-end;\n    margin-left: 30px;\n    justify-content: space-evenly;\n\n    div {\n        width:fit-content;\n    }\n\n}\n\n.rDNA-button {\n    border-radius: 15px;\n    @extend %font-20px-medium;\n    @extend %flex-column;\n    @extend %flex-jCenter-aCenter;\n    border: none;\n    font-size: 16px;\n    height: 48px;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n    width:225px;\n\n    &:last-of-type {\n        margin-bottom: 5px;\n    }\n\n    span {\n        margin-left: 10px;\n    }\n\n    &:hover {\n        opacity: 0.8;\n        cursor: pointer;\n    }\n}\n\n.share-btn {\n    color: $light-text;\n    background: $theme-1;\n}\n\n.compare-btn {\n    color: $light-text;\n    background: $accent-btn;\n    margin-left: 10px;\n}\n\n.data-btn {\n    color: $light-text;\n    background: $theme-1; // New color for the Download Data button\n    border: none;\n    transition: background-color 0.3s ease-out;\n}\n.datalocked-btn {\n    color: $theme-main;\n    background: $theme-lightgray; // New color for the Download Data button\n    border: none;\n    transition: background-color 0.3s ease-out;\n}\n\n\n\n  .padlock-container{\n    width:100%;\n    height:100%;\n    display:flex;\n    flex-direction: column;\n    align-items:center;\n    justify-content:center;\n    position:relative;\n\n\n\n}\n\n  .padlock{\n    display:none\n\n  }\n\n  .padlock.disabled{\n\n    display:block;\n    width:100%;\n    height:100%;\n    display:flex;\n    flex-direction: column;\n    align-items:flex-end;\n    justify-content:left;\n    background: radial-gradient(circle,#4c4c4750 70%, #FFFFFF50 100%);\n    position:absolute;\n    z-index:2;\n    span{\n        font-size: 20px;\n    }\n   .link{\n        width:100%;\n        height:100%;\n        align-items: start;\n        justify-content: end;\n    }\n\n  }\n\n\n.header-title-chips {\n  width: 100%;\n  padding: 10px;\n  border-radius: 12px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.header-title-label {\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0 20px;\n}\n\n.selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n\n  .chip {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border-radius: 12px;\n    padding: 7px 10px;\n    font-size: 14px;\n    color: #333;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\n    &--retailer {\n      border: 2px solid $theme-main;\n    }\n\n    &--ranking {\n      border: 2px solid $theme-contrast;\n    }\n\n    &--sector {\n      border: 2px solid $theme-1;\n    }\n\n    &--cluster {\n      border: 2px solid $theme-2;\n    }\n\n    .remove-chip {\n      margin-left: 8px;\n      cursor: pointer;\n      font-size: 14px;\n      color: #666;\n\n      &:hover {\n        color: #333;\n      }\n    }\n  }\n}\n\n.export-dropdown-container {\n  position: relative;\n}\n\n.export-dropdown {\n  position: absolute; // Changed from fixed to absolute\n  z-index: 99;\n  background-color: white;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);\n  border-radius: 3px;\n  left: 50%; // Center horizontally\n  transform: translateX(+6%); // Adjust back by half width\n  margin-top: 5px; // Optional spacing from the button\n}\n\n.export-btn-container {\n  width: 200px !important; // Fill the width of the parent (.export-dropdown)\n  padding: 16px 20px;\n  background-color: white;\n  color: $theme-back-light;\n  box-sizing: border-box;\n\n\n  span {\n    font-size: 15px;\n  }\n}\n\n.export-btn-container:hover {\n  background-color: $theme-lightgray;\n  cursor: pointer;\n}\n\n.export-dropdown-container-mobile {\n  display:none !important;\n}\n\n\n\n@media screen and (min-width: $breakpoint-2-charts) {\n    .echelon-container {\n        justify-content: space-between;\n    }\n    .export-btn-container {\n      width: 201px !important;\n    }\n}\n\n@media screen and (max-width: $breakpoint-xl-max) {\n    .list-profile-header {\n        align-items: stretch;\n    }\n    .list-name {\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-around;\n    }\n    .buttons {\n        flex-direction: row;\n        align-items: top;\n        justify-content: center;\n    }\n\n    .share-btn {\n        margin-right: 10px;\n        width:225px;\n    }\n\n  .export-dropdown {\n    transform: translateX(+6%); // Adjust back by half width\n    margin-top: 0;\n  }\n\n  .export-btn-container {\n    width: 202px !important;\n  }\n}\n\n@media screen and (max-width: $breakpoint-lg-max) {\n    .list-name {\n        flex-direction: column;\n    }\n    .buttons {\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n  .header-title-chips {\n    width: 66vw;\n  }\n\n    .selected-chips {\n      //flex-direction: column;\n    }\n    .buttons-container {\n        flex-direction:column;\n        align-items: center;\n        justify-content: center;\n    }\n    .share-btn, .rDNA-button {\n      width:350px;\n    }\n    .compare-btn {\n\n      margin-left: 0;\n    }\n\n  .export-btn-container {\n    width: 305px !important;\n  }\n\n}\n\n@media screen and (max-width: $breakpoint-md-max) {\n    .list-name {\n        flex-direction: column;\n    }\n    .buttons {\n        flex-wrap:nowrap;\n        flex-direction: column;\n\n        button {\n            margin: 5px 0 5px 0;\n        }\n    }\n  .header-title-chips {\n    width: 66vw;\n  }\n  .export-btn-container {\n    width: 305px !important;\n  }\n}\n\n@media (max-width: 767px) {\n    .list-profile-container {\n        margin: 5px;\n    }\n\n    .list-name {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .list-name-selector-form {\n        width: fit-content;\n        max-width: 100%;\n    }\n\n    .list-name-selector {\n        width: 100%;\n        font-size: clamp(10px, 20px, 25px);\n    }\n\n    .list-logo {\n        width: 70%;\n        margin-left: 10px;\n    }\n\n    .flag-icon {\n        width: 200px;\n        height: 100%;\n        margin: 0;\n    }\n\n    .banner {\n        display:flex;\n        flex-direction:column;\n        height:fit-content;\n        align-items:center;\n    }\n\n    .sponsor-area {\n        width:90vw;\n    }\n\n    .buttons {\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n\n        margin-left: 0;\n        div {\n\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            margin-bottom: 5px;\n        }\n    }\n\n    .rDNA-button,\n    .share-btn,\n    .compare-btn,\n    .data-btn {\n        width: 350px;\n        margin-right: 0;\n\n    }\n\n    .cluster {\n        width: 100vw;\n    }\n\n    .top-container {\n        width: 95vw;\n    }\n\n    img {\n        margin-left: 25px;\n    }\n\n    tr {\n        border-bottom: 1px solid rgba($theme-lightgray, 1);\n    }\n\n    .table-container {\n        margin-left:0;\n    }\n\n    .profile-table {\n        margin: 0;\n        width: auto;\n\n        th, td, span, p {\n            font-size: 11px;\n        }\n    }\n\n    .table-logo-container {\n        margin-left:0;\n        align-items: center;\n    }\n\n    .table-logo {\n        margin:0;\n        max-width: 100%;\n        max-height:60%;\n    }\n\n    .elite-table {\n        padding:0 1%;\n        word-wrap:break-word;\n\n        th {\n            width:15%;\n        }\n        th:first-child {\n            width: 7%;\n        }\n        th:last-child {\n            width: 7%;\n        }\n    }\n\n    .sm-flag-icon {\n        width:20px; height:20px;\n    }\n\n    .table-expand-button {\n        width:100vw;\n        max-width: 100vw;\n    }\n  .header-title-chips {\n    width: 95vw;\n  }\n\n  .export-dropdown-container {\n    display:none !important;\n  }\n\n  .export-dropdown-container-mobile {\n    position: relative;\n\n  }\n\n  .export-dropdown-mobile {\n    position: absolute; // Use absolute so it positions relative to the parent container\n    top: 100%; // Places it directly below the button\n    left: 50%; // Center horizontally\n    transform: translateX(-50%); // Shift it back by half its width\n    margin-top: 0;\n\n    z-index: 99;\n    background-color: white;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.254), 0 3px 10px rgba(0, 0, 0, 0.18);\n    border-radius: 3px;\n    width: 300px !important;\n    flex-direction: column;\n  }\n  .export-btn-container {\n    width: 300px !important;\n  }\n\n}\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
